module.exports = __webpack_public_path__ + "img/icon.37c0434c.png";